import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import settings from './settings'
import auth from './auth'
import grid from './grid'
import listinos from './listinos'
import contacts from './contacts'
import logs from './logs'
import analytics from './analytics'
import siteSettings from './siteSettings'

const reducers = combineReducers({
  routing: routerReducer,
  settings,
  auth,
  grid,
  listinos,
  contacts,
  logs,
  analytics,
  siteSettings
})

export default reducers



// WEBPACK FOOTER //
// ./reducers/index.js